module.exports = __webpack_public_path__ + "static/media/Throne-Room.f74b03b1.png";